module.exports = __webpack_public_path__ + "img/thumbnail_Llama_m_normal.d78cc099.png";